import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { StyledContentText } from './styles.web.js';
import { getFontSize } from './utils.js';
import { useTheme } from '../utils/theming/useTheme.js';

var ContentText = function ContentText(_ref) {
  var _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 'normal' : _ref$lineHeight,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'regular' : _ref$weight,
      _ref$italic = _ref.italic,
      italic = _ref$italic === void 0 ? false : _ref$italic,
      _ref$paragraph = _ref.paragraph,
      paragraph = _ref$paragraph === void 0 ? false : _ref$paragraph,
      children = _ref.children,
      ref = _ref.innerRef,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["lineHeight", "size", "weight", "italic", "paragraph", "children", "innerRef", "color"]);

  var theme = useTheme();
  return (
    /*#__PURE__*/
    React.createElement(StyledContentText, _extends({
      "data-test": "elemental-ContentText",
      lineHeight: lineHeight // fontSize is given as a BoxProp
      ,
      fontSize: getFontSize(theme.contentText.web.fontSizes, size),
      weight: weight,
      italic: italic,
      paragraph: paragraph,
      textColor: color,
      ref: ref,
      theme: theme
    }, props), children)
  );
};

export { ContentText };